/**
 * Safari's manual Add to Home Screen steps, shared by the iOS install gate and
 * the gear-menu InstallGuide so the two can never drift. Written for iOS 26,
 * where Share moved behind the ••• button and the "Open as Web App" switch
 * decides whether the icon opens the installed app or just Safari again; the
 * step-1 aside covers older iOS, where Share sits in the toolbar.
 */
export function IosInstallSteps() {
  return (
    <ol class="ios-install-steps" data-testid="ios-install-steps">
      <li>
        Tap <strong>•••</strong> in Safari's toolbar, then tap <strong>Share</strong>. (On older
        iPhones, tap the <strong>Share</strong> icon in the toolbar.)
      </li>
      <li>
        Scroll down and tap <strong>Add to Home Screen</strong>.
      </li>
      <li>
        Make sure <strong>Open as Web App</strong> is turned on, then tap <strong>Add</strong>.
      </li>
    </ol>
  );
}
